import {
	BaseApiService,
	BaseDeleteDto,
	BaseFindDto,
	BaseFindOneDto,
	BaseUpdateDto
} from "@remar/shared/dist/api/baseApiService";
import { Lesson } from "@remar/shared/dist/models";

import { URLS } from "../services.constants";

export class LessonRanksService extends BaseApiService<
	Lesson,
	Record<string, unknown>,
	BaseFindDto,
	BaseFindOneDto,
	BaseUpdateDto<Record<string, unknown>>,
	BaseDeleteDto
> {
	constructor(baseUrl: string) {
		super(baseUrl);
	}
}

export const lessonRanksService = new LessonRanksService(URLS.LESSON_RANKS);
